// For Get insurance_carriers
export const GET_TERMS_OF_SERVICE = "GET_TERMS_OF_SERVICE"
export const GET_TERMS_OF_SERVICE_SUCCESS = "GET_TERMS_OF_SERVICE_SUCCESS"
export const GET_TERMS_OF_SERVICE_ERROR = "GET_TERMS_OF_SERVICE_ERROR"

export const POST_TERMS_OF_SERVICE = "POST_TERMS_OF_SERVICE"
export const POST_TERMS_OF_SERVICE_SUCCESS = "POST_TERMS_OF_SERVICE_SUCCESS"
export const POST_TERMS_OF_SERVICE_ERROR = "POST_TERMS_OF_SERVICE_ERROR"

export const GET_LATEST_TERMS_OF_SERVICE = "GET_LATEST_TERMS_OF_SERVICE"
export const GET_LATEST_TERMS_OF_SERVICE_SUCCESS = "GET_LATEST_TERMS_OF_SERVICE_SUCCESS"
export const GET_LATEST_TERMS_OF_SERVICE_ERROR = "GET_LATEST_TERMS_OF_SERVICE_ERROR"

export const GET_USER_TERMS_OF_SERVICE = "GET_USER_TERMS_OF_SERVICE"
export const GET_USER_TERMS_OF_SERVICE_SUCCESS = "GET_USER_TERMS_OF_SERVICE_SUCCESS"
export const GET_USER_TERMS_OF_SERVICE_ERROR = "GET_USER_TERMS_OF_SERVICE_ERROR"

export const CREATE_USER_TERMS_OF_SERVICE = "CREATE_USER_TERMS_OF_SERVICE"
export const CREATE_USER_TERMS_OF_SERVICE_SUCCESS = "CREATE_USER_TERMS_OF_SERVICE_SUCCESS"
export const CREATE_USER_TERMS_OF_SERVICE_ERROR = "CREATE_USER_TERMS_OF_SERVICE_ERROR"